import React, { Component } from 'react';

export default class Logo extends Component {
  render() {
    return (
      <svg style={{ width: `${this.props.width}px`, height: `${this.props.height}px` }}>
        <g transform={`matrix(${this.props.scale} 0 0 ${this.props.scale} ${this.props.width / 2} ${this.props.height / 2})`}>
          <path d="M -73 -372 Q -85 -372 -98 -364 L -117 -345 L -204 -195 L -202 -195 L -350 58 Q -369 92 -355 114 Q -342 138 -304 138 L 24 138 L 34 121 L -185 121 Q -197 121 -202 114 Q -207 107 -202 97 L 70 -372 Z M -24 -138 L -34 -121 L 184 -121 Q 197 -121 202 -114 Q 208 -105 201 -97 L -70 372 L 72 372 L 97 366 L 117 347 L 204 196 L 202 196 L 235 139 L 350 139 L 361 122 L 245 122 L 349 -58 Q 367 -90 354 -114 Q 340 -138 303 -138 Z" fill="rgb(0,0,1)" fillOpacity="1.000"></path>
        </g>
      </svg>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./components/Logo.js
 **/